import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { useIsFetching } from '@tanstack/react-query';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { OfferCurrencyAlert } from 'v2/components/Shared/OfferCurrencyAlert';
import { Space } from 'v2/components/Shared/Space';

import type { ProductOffer } from 'v2/interfaces/product';

import { ActionsMenu } from './ActionsMenu';
import { LinksModal } from './LinksModal';
import { List } from './List';
import { useStyles } from './styles';
import { FormContent } from '../../../FormContent';

import type IProduct from 'interfaces/IProduct';

type OffersProps = {
  product: IProduct;
  loading: boolean;
  hasUnsavedChanges: boolean;
  openConfirmModal: (cancelModalCallback?: undefined | (() => void)) => void;
};

function Offers({ product, loading, hasUnsavedChanges, openConfirmModal }: OffersProps) {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [offer, setOffer] = React.useState<ProductOffer | undefined>(undefined);
  const [isLinksModalOpen, setIsLinksModalOpen] = React.useState(false);
  const isOffersLoading = useIsFetching({
    queryKey: ['products', product.id, 'offers'],
    exact: true,
  });

  function navigateToCreateOffer() {
    history.push(`/producer/product/${product.id}/offers/create`, {
      product,
    });
  }

  function handleCreateOffer() {
    if (hasUnsavedChanges) {
      openConfirmModal(navigateToCreateOffer);
      return;
    }

    navigateToCreateOffer();
  }

  const handleActionsClick = React.useCallback((event: React.MouseEvent<HTMLButtonElement>, offer: ProductOffer) => {
    setAnchorEl(event.currentTarget);
    setOffer(offer);
  }, []);

  function handleMenuClose() {
    setAnchorEl(null);
  }

  return (
    <FormContent title='Ofertas' loading={loading || isOffersLoading > 0}>
      <header className={classes.header}>
        <Typography>Cadastre ofertas especiais para seu produto e defina um valor especifico para cada moeda.</Typography>
        <Button id='create-offer-button' onClick={handleCreateOffer} variant='contained' color='primary'>
          Cadastrar nova oferta
        </Button>
      </header>
      <Space axis='vertical' size={32} />
      <List productId={product.id} handleActionsClick={handleActionsClick} />
      <Space axis='vertical' size={16} />
      <OfferCurrencyAlert />
      <ActionsMenu
        anchorEl={anchorEl}
        closeMenu={handleMenuClose}
        openLinksModal={() => setIsLinksModalOpen(true)}
        product={product}
        offer={offer}
        openConfirmModal={openConfirmModal}
        hasUnsavedChanges={hasUnsavedChanges}
      />
      {offer && <LinksModal isOpen={isLinksModalOpen} closeModal={() => setIsLinksModalOpen(false)} offer={offer} />}
    </FormContent>
  );
}

export { Offers };
